
export default () => {
    const siteHeaderEl = document.querySelector('.site-header');
    const headerNavEl = siteHeaderEl.querySelector('.site-header__nav');
    const winWidth = window.innerWidth;
    // Toggla menyn
    $('.site-header__nav-toggle').click(() => {
        document.body.classList.toggle('stop-scrolling');
        siteHeaderEl.classList.toggle('site-header--menu-open');

        const hidden = headerNavEl.getAttribute('aria-hidden');
        headerNavEl.setAttribute('aria-hidden', hidden === 'true' ? 'false' : 'true');
    });


    /** Slider block */
    const blockSlider = document.querySelector('.glide');
    if(blockSlider !== null) {
        var blockGlide = new Glide('.glide', {
            type: 'slider',
            autoplay: 15000,
            perView: 1,
        });
        blockGlide.mount();
    }

    /** Main menu */
    $('.menu-item-has-children > a').after('<button class="dropdown-btn"></button>');
    $('.dropdown-btn').on('click', function() {
        $(this).parent().toggleClass('active');
    });

    $('#closeNewsletter').on('click', function() {
        $('.newsletter').fadeOut();
        $('.tint').removeClass('active');
    });

    if (winWidth > 1024) {
        $('.menu-item').hover(function() {
            let translatedText = $(this).children('a').data('translated-text');
            let originalWidth = $(this).children('a').outerWidth();
            $(this).children('a').text(translatedText);
            $(this).children('a').css('min-width', originalWidth);
            }, function() {
            let originalText = $(this).children('a').data('original-text');
            $(this).children('a').text(originalText);
        });
    }
};
